import { jsx as C } from "react/jsx-runtime";
const l = () => /* @__PURE__ */ C(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1C6.06294 1 1.25 5.81294 1.25 11.75C1.25 17.6871 6.06294 22.5 12 22.5C17.9371 22.5 22.75 17.6871 22.75 11.75C22.75 5.81294 17.9371 1 12 1ZM13 7C13 6.44772 12.5523 6 12 6C11.4477 6 11 6.44772 11 7V12C11 12.323 11.156 12.626 11.4188 12.8137L14.9188 15.3137C15.3682 15.6347 15.9927 15.5307 16.3137 15.0812C16.6347 14.6318 16.5307 14.0073 16.0812 13.6863L13 11.4854V7Z",
    fill: "currentColor"
  }
);
export {
  l as default
};
